import React from "react";

function MiscFAQ(props) {
    //return
    return (<div className="container" style={{ marginTop: "6rem" }}>
        {/* Title */}
        <div className="text-center">
            <label className="display-6 fw-bold text-dark">
                FAQ
            </label>
        </div>

        {/* faq list */}
        {faqGridListView(props.faq_list)}
    </div>);
}

/* Grid List View */
function faqGridListView(faq_list) {
    return (
        <div className="accordion mt-5" id="accordion_faq">
            {faq_list.map((item, index) => (
                <div className="accordion-item" key={index}>
                    {/* Header */}
                    <h2 className="accordion-header" id={`heading_${index}`} >
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse_${index}`} aria-expanded="false" aria-controls={`collapse_${index}`}>
                            {item.title}
                        </button>
                    </h2>
                    {/* Content */}
                    <div id={`collapse_${index}`} className="accordion-collapse collapse" aria-labelledby={`heading_${index}`} data-bs-parent="#accordion_faq">
                        <div className="accordion-body">
                           { item.description}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}


export default MiscFAQ;